import styled from "styled-components";
import { ChangeEvent, FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Text from "@/components/Text";
import {
  InputGroup,
  ResetButton,
  ResetHolder,
  StyledInput,
  Wrapper,
} from "@/pages/AssignTopics/components/Filter";
import { selectTeamSettings } from "@/selectors";
import { Dispatch, RootState } from "@/utils/store";
import useDebounce from "@/hooks/useDebounce";
import useDidUpdate from "@/hooks/useDidUpdate";
import { TeamSettings } from "@/types/resources";

const StyledText = styled(Text)`
  font-size: 11px;
`;

interface Props {
  category: string;
}

const TopTopicsFilter: FC<Props> = ({ category }) => {
  const dispatch = useDispatch<Dispatch>();

  const { teamId } = useParams();

  const teamSettings = useSelector((rootState: RootState) =>
    selectTeamSettings(rootState, teamId!)
  );

  const minVideosCount =
    teamSettings?.[`top_${category}_topics_min_videos` as keyof TeamSettings];

  const [value, setValue] = useState(minVideosCount || "");

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
      setValue(e.target.value);
    }
  };

  const debouncedValue = useDebounce(value, 500);

  useDidUpdate(() => {
    if (debouncedValue === minVideosCount) {
      return;
    }

    dispatch.teams.updateSettings({
      teamId: teamId!,
      updatedSettings: {
        [`top_${category}_topics_min_videos`]: debouncedValue,
      },
    });
  }, [debouncedValue, teamId]);

  useDidUpdate(() => {
    setValue(minVideosCount ?? "");
  }, [category]);

  return (
    <InputGroup>
      <StyledText $type="smallBold" $color="black">
        Minimum videos
      </StyledText>
      <Wrapper>
        <ResetHolder>
          <ResetButton onClick={() => setValue("")}>reset</ResetButton>
        </ResetHolder>
        <StyledInput
          placeholder="Enter number"
          name={`minVideos`}
          value={value}
          onChange={onChange}
        />
      </Wrapper>
    </InputGroup>
  );
};

export default TopTopicsFilter;
